import axios from 'axios';
import React, { useState, useEffect, useContext, ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { User } from './types';
import LogRocket from 'logrocket'


declare global {
    interface Window {
      $crisp: any
    }
  }
interface Props {
    children: ReactNode;
}

const defaultUser = {
    id: 0,
    clientId: 0,
    clientName: '',
    firstName: '',
    lastName: '',
    email: ''
}

const UserContext = React.createContext<any | null>({});

const UserContextComponent = ({ children }: Props) => {
    const history = useHistory();
    const [user, setUser] = useState<User>(defaultUser)

    const setUserContext = async () => {
        const { data } = await axios.get(`/api/clientaccount/isauthenticated`)
        if (data.isAuthenticated) {
            setUser(data.user);
            LogRocket.identify(data.user.id, {
                name: `${data.user.firstName} ${data.user.lastName}`,
                email: data.user.email,
                clientName: data.user.clientName
              })
        }
        return data.isAuthenticated;
    }

    useEffect(() => {
        axios.get(`/api/clientaccount/isauthenticated`)
            .then(({ data }: any) => {
                if (data.isAuthenticated) {
                    setUser(data.user);
                    window.$crisp.push(["set", "session:data", [
                        [
                          ["client_name", `${data.user.clientName}`],
                          ["client_user", `${data.user.firstName} ${data.user.lastName}`],
                        ]
                      ]])
                      LogRocket.identify(data.user.id, {
                        name: `${data.user.firstName} ${data.user.lastName}`,
                        email: data.user.email,
                        clientName: data.user.clientName
                      })
                }

                if (window.location.pathname === '/login' ||
                    window.location.pathname === '/forgot-password' ||
                    window.location.pathname.startsWith('/reset-password') ||
                    window.location.pathname.startsWith('/activate')) {
                    if (data.isAuthenticated) {
                        history.replace('/home');
                    }
                    else if (!data.isAuthenticated) {
                        return;
                    }
                }
                else {
                    if (data.isAuthenticated) {
                        return;
                    }
                    else if (!data.isAuthenticated) {
                        history.push('/login')
                    }
                }
            })
    }, [])

    axios.interceptors.response.use(response => response, function (error) {
        if (error.message === 'Request failed with status code 401') {
            window.location.reload();
            return;
        }
        return Promise.reject(error);
    });

    const value = {
        user,
        setUserContext
    }

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    )
}

const useUserContext = () => useContext(UserContext);

export { useUserContext, UserContextComponent, UserContext }